import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5ae0f5b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "banners" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "points" }
const _hoisted_5 = ["onClick"]

import home, { State } from '@/store/movies/home';
import { computed, onBeforeUnmount, onMounted, reactive } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const data = computed<State>(() => store.state[home.name])
const banners = computed(() => data.value.banners.slice(0, state.bannerSize))
const state = reactive({
    size: 0,
    current: 0,
    timer: 0,
    bannerSize: 1,
})

onMounted(() => {
    setTimeout(() => {
        state.size = data.value.banners.length;
        if (data.value.banners.length > 1) {
            //@ts-ignore
            state.timer = setInterval(onTimer, 3000)
            if (data.value.banners.length == 2) {
                data.value.banners = [...data.value.banners, ...data.value.banners]
            }
            state.bannerSize = data.value.banners.length;
        }
    }, 3000);
})
onBeforeUnmount(() => {
    clearInterval(state.timer)
})
function onTimer() {
    state.current = (state.current + 1) % data.value.banners.length
}
function cls(i: number) {
    if (i == state.current) {
        return 'on'
    }
    if (i == (state.current + 1) % data.value.banners.length) {
        return 'next'
    }
    if (i == (state.current - 1 + data.value.banners.length) % data.value.banners.length) {
        return 'prev'
    }
    return ''
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(banners), (item, i) => {
      return (_openBlock(), _createElementBlock("a", {
        class: _normalizeClass(["item", cls(i)]),
        key: i,
        href: item.linkurl,
        target: "_blank"
      }, [
        _createElementVNode("img", {
          src: item.image
        }, null, 8, _hoisted_3)
      ], 10, _hoisted_2))
    }), 128)),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).size, (item, i) => {
        return (_openBlock(), _createElementBlock("a", {
          class: _normalizeClass({ on: i == _unref(state).current }),
          onClick: ($event: any) => (_unref(state).current = i)
        }, null, 10, _hoisted_5))
      }), 256))
    ])
  ]))
}
}

})